module.exports = __webpack_public_path__ + "static/media/growcrazy2.ede0e945.jpg";